import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { PcfBasketResponse } from 'src/app/models/portfolio-models/pcf-basket-response.model'
import { PortfolioHoldingResponse } from 'src/app/models/portfolio-models/portfolio-holding-response.model'

@Injectable({
  providedIn: 'root',
})
export class PortfolioHoldingService {
  public static readonly portfolioHoldingEndpoint = '/portfolio-holding'

  constructor(private readonly http: HttpClient) {}
  getPortfolioHoldings(
    fundId: string,
    type: string,
    incomingParams: Record<string, string | number>,
  ): Observable<PortfolioHoldingResponse | PcfBasketResponse> {
    const outgoingParams = { params: incomingParams }
    return this.http.get<PcfBasketResponse>(
      `vmf/api/${fundId}${PortfolioHoldingService.portfolioHoldingEndpoint}/${type}.json`,
      outgoingParams,
    )
  }
}
